import React, { Component } from 'react';
import Context from './context';

class contextProvider extends Component{

    state={
        sideBarUserBool:true,
        sideBarAdminBool:false,
        sideBarSpecialBool:false
    };

    render(){
        return(
            <Context.Provider
                value={{
                    state:this.state,
                    sideBarUserChange:()=>this.setState({
                        sideBarUserBool: this.state.sideBarUserBool = true,
                        sideBarAdminBool:this.state.sideBarAdminBool =false,
                        sideBarSpecialBool:this.state.sideBarSpecialBool=false
                    }),
                    sideBarAdminChange:()=>this.setState({
                        sideBarUserBool: this.state.sideBarUserBool = false,
                        sideBarAdminBool:this.state.sideBarAdminBool =true,
                        sideBarSpecialBool:this.state.sideBarSpecialBool=false
                    }),
                    sideBarSpecialChange:()=>this.setState({
                        sideBarUserBool: this.state.sideBarUserBool = false,
                        sideBarAdminBool:this.state.sideBarAdminBool =false,
                        sideBarSpecialBool:this.state.sideBarSpecialBool=true
                    })
                }}
            >
                {this.props.children}
            </Context.Provider>
        )
    }
}

export default contextProvider;



// WEBPACK FOOTER //
// ./src/contextProvider.js